export default "__VITE_ASSET__48dd58db__"